import { useEffect, useRef } from 'react';
import type { OrgEvent } from './contracts';

type Listener = (e: OrgEvent) => void;
const listeners = new Set<Listener>();

/**
 * In-app fan-out of the org SSE stream (`/api/events`). The single connection lives in the app shell
 * (`useOrgEvents`); components subscribe here for targeted refetches instead of polling.
 */
export const orgEvents = {
  emit(e: OrgEvent) {
    for (const l of listeners) l(e);
  },
  on(l: Listener) {
    listeners.add(l);
    return () => {
      listeners.delete(l);
    };
  },
};

/** Subscribe to org events for the lifetime of the component (the latest handler is always used). */
export function useOrgEvent(handler: Listener) {
  const ref = useRef(handler);
  ref.current = handler;
  useEffect(() => orgEvents.on((e) => ref.current(e)), []);
}
